import { Container, Item } from 'Components/Grid';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import { contraception } from 'neuro-schemas';
import * as React from 'react';
import { useAppSelector } from 'Store/index';
import browserLanguage from 'Utility/browserLanguage';

const ContraceptionHistoryRowData = ({ d }: IOwnProps): React.JSX.Element => {
  const locale = useAppSelector(state => state.settings.userSettings.uiLanguage) ?? browserLanguage;
  const localizations = contraception.getLocalizations(locale);
  return (
    <Container alignItems="flex-start">
      <Item xs={2}>
        <HistoryRowBasicItem
          header={localizations['contraceptiveClassification.title']}
          value={
            d.contraceptiveClassification
              ? localizations[`contraceptiveClassification.opts.${d.contraceptiveClassification}`]
              : '-'
          }
        />
      </Item>
      <Item xs={7}>
        {d.contraceptiveClassification === 'noContraception' && (
          <HistoryRowBasicItem header={localizations['cause.title']} value={d.cause ?? '-'} />
        )}
        {d.contraceptiveClassification !== 'noContraception' && (
          <HistoryRowBasicItem
            header={localizations['contraceptive.title']}
            value={d.contraceptive ? localizations[`contraceptive.opts.${d.contraceptive}`] : '-'}
          />
        )}
      </Item>
    </Container>
  );
};

interface IOwnProps {
  d: IDocumentWithTypeV2<'contraception'>;
}

export default ContraceptionHistoryRowData;
